var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_1141)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.69021 14.4573C9.71554 14.5205 9.75957 14.5743 9.81639 14.6117C9.87322 14.6491 9.94011 14.6682 10.0081 14.6664C10.0761 14.6647 10.1419 14.6422 10.1968 14.6019C10.2516 14.5617 10.2928 14.5057 10.3149 14.4413L14.6482 1.77466C14.6695 1.71559 14.6736 1.65167 14.66 1.59037C14.6463 1.52907 14.6154 1.47293 14.571 1.42852C14.5266 1.3841 14.4705 1.35326 14.4092 1.33959C14.3479 1.32592 14.2839 1.32999 14.2249 1.35133L1.55821 5.68466C1.49388 5.70673 1.43783 5.74794 1.39759 5.80278C1.35736 5.85761 1.33486 5.92344 1.33312 5.99144C1.33138 6.05943 1.35047 6.12632 1.38785 6.18315C1.42523 6.23997 1.47909 6.284 1.54221 6.30933L6.82888 8.42933C6.996 8.49624 7.14785 8.5963 7.27526 8.72348C7.40266 8.85066 7.503 9.00233 7.57021 9.16933L9.69021 14.4573Z",
    stroke: "currentColor",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5697 1.43132L7.27637 8.72398",
    stroke: "currentColor",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1141"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendIcon2);
export default __webpack_public_path__ + "static/media/send_icon_2.323eb5ab3ffb79a167d845e663a29ba6.svg";
export { ForwardRef as ReactComponent };